// extracted by mini-css-extract-plugin
export default {"tenantTypography":"styles_tenantTypography__FV8wQ","badge":"styles_badge__6-NSG","code":"styles_code__v8z0Q","name":"styles_name__q8tkJ"};